export default {
  audioinput: 'Microphone',
  videoinput: 'Video Camera',
  audioouput: 'Speaker',
  deviceChangeNotice: '{{type}} switched to {{label}}',
}
